import React, { useEffect, useState } from "react";
import { InlineRichText } from "../RichText";
import { Container, Hero, Tagline, Tile, Title } from "./styles";

const QuizCta = ({ quiz, onPress }) => {
    const windowWidth = 800;
    const imageUrl = `https:${quiz.photo.url}?w=${windowWidth}&fm=jpg`;
    const [marginBottom, setMarginBottom] = useState(34);

    const { title, titleRich, tagline, taglineRich } = quiz;

    const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;
    const theTag = taglineRich ? <InlineRichText doc={taglineRich} /> : tagline;

    /**
     * TODO: Remove this.
     * This is a fix for an odd bug where the strategies section isn't
     * acknowledging the height of QuizCta. Triggering a change to layout post-render fixes
     * the display. This bug might only be on Simulator. ILM 07-28-20
     */
    useEffect(() => {
        setTimeout(() => setMarginBottom(35), 100);
    }, []);

    return (
        <Container onPress={onPress} marginBottom={marginBottom}>
            <Hero source={{ uri: imageUrl }} />
            <Tile>
                <Title type="ctah3">{theTitle}</Title>
                <Tagline type="body2">{theTag}</Tagline>
            </Tile>
        </Container>
    );
};

export default QuizCta;
